import { render, staticRenderFns } from "./middleware.vue?vue&type=template&id=59253262&"
import script from "./middleware.vue?vue&type=script&lang=js&"
export * from "./middleware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports